import script from "./ConversationView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConversationView.vue?vue&type=script&setup=true&lang=ts"

import "./ConversationView.vue?vue&type=style&index=0&id=ec046e40&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec046e40"]])

export default __exports__